import { Route } from "react-router-dom";
import ProtectedRoute from "../protectedRoute";
import {
  MODULES_LIST,
} from "../../../utils/helper";

import GeneralSetup from "../../main/configuration/generalSetup/page";
import ManageTemplates from "../../main/configuration/manageTemplates/page";
import AuditLog from "../../main/configuration/auditLogs/page";
import ManageHistory from "../../main/configuration/manageHistory/page";


const configurationRoutes = [

  // {
  //   path: "/configuration/manage-templates",
  //   element: <ManageTemplates />,
  //   access: [],
  //   module: MODULES_LIST.CONFIGURATION,
  //   subModule: null,
  // },
  // {
  //   path: "/configuration/settings",
  //   element: <WorkspaceSettings />,
  //   access: [],
  //   module: MODULES_LIST.CONFIGURATION,
  //   subModule: null,
  // },
  {
    path: "/configuration/logs",
    element: <AuditLog />,
    access: [],
    module: MODULES_LIST.CONFIGURATION,
    subModule: null,
  },
  // {
  //   path: "/configuration/custom-fields",
  //   element: <CustomFields />,
  //   access: [],
  //   module: MODULES_LIST.CONFIGURATION,
  //   subModule: null,
  // },
  // {
  //   path: "/configuration/custom-fields/:action/:id?",
  //   element: <AddCustomFields />,
  //   access: [],
  //   module: MODULES_LIST.CONFIGURATION,
  //   subModule: null,
  // },
  // {
  //   path: "/configuration/import",
  //   element: <FileImport />,
  //   access: [],
  //   module: MODULES_LIST.CONFIGURATION,
  //   subModule: null,
  // },
  {
    path: "/configuration/themes",
    element: <ManageTemplates />,
    access: [],
    module: MODULES_LIST.CONFIGURATION,
    subModule: null,
  },
  {
    path: "/configuration/general-setup",
    element: <GeneralSetup />,
    access: [],
    module: MODULES_LIST.CONFIGURATION,
    subModule: null,
  },
  // {
  //   path: "/configuration/credentials",
  //   element: <ImportCredential />,
  //   access: [],
  //   module: MODULES_LIST.CONFIGURATION,
  //   subModule: null,
  // },
  {
    path: "/configuration/packages-payment-history",
    element: <ManageHistory />,
    access: [],
    module: MODULES_LIST.CONFIGURATION,
    subModule: null,
  },
  // {
  //   path: "/configuration/manage-history/package-view/:id?",
  //   element: <PackageHistoryView />,
  //   access: [],
  //   module: MODULES_LIST.CONFIGURATION,
  //   subModule: null,
  // },
  // {
  //   path: "/configuration/manage-history/payment-view/:id?",
  //   element: <PaymentHistoryView />,
  //   access: [],
  //   module: MODULES_LIST.CONFIGURATION,
  //   subModule: null,
  // },
  // {
  //   path: "/configuration/manage-history/storage-view/:id?",
  //   element: <StorageHistoryView />,
  //   access: [],
  //   module: MODULES_LIST.CONFIGURATION,
  //   subModule: null,
  // },
  // {
  //   path: "/configuration/examination-setup",
  //   element: <ConfigureManageExamination />,
  //   access: [],
  //   module: MODULES_LIST.CONFIGURATION,
  //   subModule: null,
  //   children: [
  //     {
  //       path: "", 
  //       element: <ManageExaminationSetup />,
  //       access: [],
  //       module: MODULES_LIST.CONFIGURATION,
  //       subModule: null,
  //     },
  //     {
  //       path: "grade", 
  //       element: <ManageGrade />,
  //       access: [],
  //       module: MODULES_LIST.CONFIGURATION,
  //       subModule: null,
  //     },
  //     {
  //       path: "instructions", 
  //       element: <Instruction />,
  //       access: [],
  //       module: MODULES_LIST.CONFIGURATION,
  //       subModule: null,
  //     },
  //     {
  //       path: "instructions/:action/:id?", 
  //       element: <AddInstruction />,
  //       access: [],
  //       module: MODULES_LIST.CONFIGURATION,
  //       subModule: null,
  //     },
  //   ],
  // }
];

export default function renderConfigurationRoutes() {
  const renderRoute = (route, access = false) => {
    if (route.children && route.children.length > 0) {
      return (
        <Route
          key={route.path}
          path={route.path}
          element={
            <ProtectedRoute
              module={route.module}
              submodule={route.subModule}
              access={route.access}
              path={route.path}
            >
              {route.element}
            </ProtectedRoute>
          }
        >
          {/* Render child routes without extra permission checks */}
          {route.children.map((child) => (
            <Route key={child.path} path={child.path} element={child.element} />
          ))}
        </Route>
      );
    }
    return (
      <Route
        key={route.path}
        path={route.path}
        element={
          access ? (
            route.element
          ) : (
            <ProtectedRoute
              module={route.module}
              submodule={route.subModule}
              access={route.access}
              path={route.path}
            >
              {route.element}
            </ProtectedRoute>
          )
        }
      />
    );
  };
  return configurationRoutes.map((route) => renderRoute(route));
}
